import { Card, CardProps, styled } from '@mui/material';

const RoundedCard = styled(Card)<CardProps>(() => ({
  padding: '1rem',
  border: 'solid 1px rgba(0, 0, 0, 0.1)',
  borderRadius: '10px',
}));

const StyledCard = (props: CardProps) => (
  <RoundedCard elevation={0} {...props} />
);

export default StyledCard;
